import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "./logo.png"; // Make sure the path to your logo.png is correct
import './App.css'; // Ensure the CSS file is imported

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setScrolled(scrollTop > 100);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarStyle = {
    width: "100%",
    display: "flex",
    alignItems: "center",
    padding: "20px 0",
    position: "fixed",
    top: 0,
    zIndex: 20,
    backgroundColor: "black",
    transition: "background-color 0.3s, box-shadow 0.3s",
    boxShadow: scrolled ? "0 4px 2px -2px gray" : "none",
    animation: "fadeInFast ease 1s",
    animationFillMode: "forwards",
  };

  const containerStyle = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 20px",
  };

  const logoStyle = {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
  };

  const logoImgStyle = {
    width: "50px",
    height: "auto",
  };

  const titleStyle = {
    color: "white",
    fontSize: "18px",
    fontWeight: "bold",
    marginLeft: "10px",
  };

  return (
    <nav style={navbarStyle}>
      <div style={containerStyle}>
        <Link to="/" style={logoStyle}>
          <img src={logo} alt="logo" style={logoImgStyle} />
          <p style={titleStyle}>HBA HOUSING</p>
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;